import { MenuItem } from '@/components/accordion/Accordion';
import { ApiResponse } from '@/react-query/context/ApiClientContextController';
import { queryFactoryOptions } from '@/react-query/utills/queryFactoryOptions';
import { AxiosInstance } from 'axios';

const getFunctionWithPermission = (client: AxiosInstance) => async (roleId: string) => {
  return (
    await client.get<ApiResponse<MenuItem[]>>('/get-function-with-permission', {
      params: { roleId: roleId },
    })
  ).data;
};

export const privilegesQueries = {
  all: () => ['privileges'] as const,
  functions: (roleId: string) =>
    queryFactoryOptions({
      queryKey: [...privilegesQueries.all(), roleId] as const,
      queryFn: (client: AxiosInstance) => () => getFunctionWithPermission(client)(roleId),
    }),
};
